module.exports = __webpack_public_path__ + "img/product_bg_9.6cda84ee.jpg";